import Vue from 'vue';
import todoDB from '@mobile/db/todos';

const TODO_TYPES = {
    ISSUE: 0,
    INSPECTION: 10,
};

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        all: (state) => state.todos,
        issues: (state) => state.todos.filter((todo) => todo.type === TODO_TYPES.ISSUE),
        inspections: (state) => state.todos.filter((todo) => todo.type === TODO_TYPES.INSPECTION),
    },

    actions: {
        async updateAll({ dispatch }, progress) {
            // this needs to work offline, so we don't care about connection problems, or even server errors
            // we ignore everything
            try {
                await todoDB.updateAll(progress);
            } catch (error) {}

            await dispatch('loadFromDB');
        },

        async detachDraft(_params, todoId) {
            console.log('detachin for todo', todoId);
            const todo = await todoDB.get(todoId);
            // this can fail if we are detaching a draft with a todo that is no longer there
            // because somebody else already did it.
            if (todo) {
                delete todo.draft;
                await todoDB.put(todo);
            }
        },

        async loadFromDB({ commit }) {
            const todos = await todoDB.getAll();
            commit('updateTodos', todos);
        },

    },

    mutations: {
        reset(state) {
            Object.assign(state, getDefaultState());
        },

        updateTodos(state, todos) {
            Vue.set(state, 'todos', todos);
        },
    },

};

function getDefaultState() {
    return {
        todos: [],
    };
}
